export default "assets/images/logo-19a9b168.png";